import React from "react"

import WorkOrdersTable from "./WorkOrdersTable"

const WorkOrders = () => (
  <div className="bg-white px-2 lg:px-6">
    <WorkOrdersTable />
  </div>
)

export default WorkOrders
